import { IncomeDTO, IncomeFrequency, IncomeModel, IncomeType } from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export interface UpsertIncomeDTO extends EmploymentFormValues {
  clientId: string;
  id: string | null;
  incomeType: IncomeType;
}

export interface EmploymentFormValues {
  Name: string;
  Earner: string;
  Amount: number | null;
  Inflation: number | null;
  IncomeFrequency: IncomeFrequency | null;
  YearlyTaxableAmount: number | null;
  BonusCommissions: number | null;
  StartAge: number | null | undefined;
  EndAge: number | null | undefined;
  EndAtRetirement: boolean | null;
  IsTaxFree: boolean | null;
  SelfEmployed: boolean | null;
  OrionManagementStyleId: number | null;
  CustomBucketIndex: number | null;
}

const defaultValues = {
  Name: '',
  Amount: null,
  Inflation: null,
  IncomeFrequency: IncomeFrequency.Yearly,
  YearlyTaxableAmount: null,
  BonusCommissions: null,
  StartAge: undefined,
  EndAge: undefined,
  EndAtRetirement: false,
  IsTaxFree: false,
  SelfEmployed: false,
  OrionManagementStyleId: null,
  CustomBucketIndex: null,
};

export const dataToForm = (income: IncomeModel | null, data: IncomeDTO): EmploymentFormValues => {
  const { Options: options } = data;

  if (!income) {
    return { ...defaultValues, Earner: options.OwnerOptions[0] };
  }

  return {
    ...income,
    IncomeFrequency:
      income.IncomeFrequency !== null ? income.IncomeFrequency : IncomeFrequency.Yearly,
    EndAge: income.EndAtRetirement ? null : income.EndAge ? income.EndAge : undefined,
    CustomBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
  };
};
